import React from "react";

import styled from "styled-components";
import tw from "twin.macro";
import {SectionHeading, Subheading as SubheadingBase} from "components/misc/Headings.js";
import {SectionDescription} from "components/misc/Typography.js";
import {Container, ContentWithPaddingXl} from "components/misc/Layouts.js";
import {ReactComponent as SvgDecoratorBlob1} from "images/svg-decorator-blob-7.svg";
import {ReactComponent as SvgDecoratorBlob2} from "images/svg-decorator-blob-8.svg";
import HelpIcon from "images/new-ui-imgs/help.png";

const Subheading = tw(SubheadingBase)`mb-4 text-center`;
const Heading = tw(SectionHeading)`w-full`;
const Description = tw(SectionDescription)`w-full text-center`;

const Column = tw.div`flex flex-col items-center`;
const HeaderContent = tw.div``;

const FAQSContainer = tw.dl`mt-12 max-w-4xl relative`;
const FAQ = tw.div`cursor-pointer select-none mt-5 md:px-8 px-0 py-5 sm:py-4 rounded-lg text-gray-800 transition duration-300`;
const Question = tw.dt`flex items-center bg-gray-200 py-2 px-4 rounded-md`;
const QuestionText = tw.span`text-lg font-semibold` ;


const Answer = tw.dd`pointer-events-none text-sm sm:text-base leading-relaxed p-4 px-8`;

const DecoratorBlob1 = styled(SvgDecoratorBlob1)`
  ${tw`pointer-events-none -z-20 absolute right-0 top-0 h-56 w-56 opacity-15 transform translate-x-2/3 -translate-y-12 text-teal-400`}
`;
const DecoratorBlob2 = styled(SvgDecoratorBlob2)`
  ${tw`pointer-events-none -z-20 absolute left-0 bottom-0 h-64 w-64 opacity-15 transform -translate-x-2/3 text-primary-500`}
`;
const HighlightedText = tw.span`text-primary-500`;

export default ({
  subheading = "",
  heading =
    <>
      Got Questions? <HighlightedText>We’ve Got You.</HighlightedText>
    </>
  ,
  description = "",
  faqs = [
    {
      question: "Is it accurate?",
      answer:
          "Yes. This is the same type of motion scan used by top athletes and coaches. You’ll get results backed by real data, not just opinions."
    },
    {
      question: "Is this better than a physio?",
      answer: "It’s different. Physios look at you with the eye of faith test. MAI Motion shows you detailed body data that even a trained eye can miss. Many physios now use it to help guide treatment."
    },
    {
      question: "Is it pricey?",
      answer: "Not at all. It’s more affordable than a few physio visits—and gives you insight that can save months of trial and error."
    },
  ]
}) => {

  return (
    <Container style={{ width: "100%" }}>
        <Column>
          <HeaderContent>
            {subheading && <Subheading>{subheading}</Subheading>}
            <Heading>{heading}</Heading>
            {description && <Description>{description}</Description>}
          </HeaderContent>
          <FAQSContainer>
            {faqs.map((faq, index) => (
              <FAQ
                key={index}
                className="group"
              >
                <Question>
                  <img src={HelpIcon} alt="Help" style={{ marginRight: 20 }} />
                  <QuestionText>{faq.question}</QuestionText>
                </Question>
                <Answer
                  variants={{
                    open: { opacity: 1, height: "auto", marginTop: "16px" },
                    collapsed: { opacity: 0, height: 0, marginTop: "0px" }
                  }}
                  initial="collapsed"
                  animate="open"
                  transition={{ duration: 0.3, ease: [0.04, 0.62, 0.23, 0.98] }}
                >
                  {faq.answer}
                </Answer>
                {faq.answer1 ? <Answer
                  variants={{
                    open: { opacity: 1, height: "auto", marginTop: "16px" },
                    collapsed: { opacity: 0, height: 0, marginTop: "0px" }
                  }}
                  initial="collapsed"
                  animate="open"
                  transition={{ duration: 0.3, ease: [0.04, 0.62, 0.23, 0.98] }}
                >
                  {faq.answer1}
                </Answer> : null}
              </FAQ>
            ))}
          </FAQSContainer>
        </Column>
      <DecoratorBlob1/>
      <DecoratorBlob2 />
    </Container>
  );
};
